import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const topComplimentsResponse = z.array(
  z.object({
    compliment: z.string(),
    num_compliments: z.number(),
  })
)

export type TopCompliments = z.infer<typeof topComplimentsResponse>

export async function getTopCompliments(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/top_compliments', data, { signal })
    .then((res) => res.data.top_compliments ?? [])
}

export async function getTopComplimentsCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/top_compliments/csv', data, { signal })
    .then((response) => response.data)
}
